import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Container,
} from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AuthLogo from '../../components/common/AuthLogo';
import hosannaTextLogo from '../../assets/hosanna_text_logo.png';

function VerifyCode({ phoneNumber, sessionInfo, onVerifyCode, onResendCode, loading }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!code) {
      setError('Verification code is required');
      return;
    }

    if (code.length !== 6) {
      setError('Code must be 6 digits');
      return;
    }

    try {
      await onVerifyCode(sessionInfo, code);
    } catch (err) {
      setError(err.message || 'Invalid verification code');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          minHeight: '100vh',
          backgroundColor: 'background.default',
          pt: 4,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: 400 }}>
          <Box
            component="img"
            src={hosannaTextLogo}
            alt="Hosanna"
            sx={{
              maxWidth: { xs: '200px', sm: '250px' },
              width: '100%',
              height: 'auto',
              mb: 3,
            }}
          />
        <Card sx={{ width: '100%' }}>
          <CardContent sx={{ p: 4 }}>
            <AuthLogo maxWidth={150} maxHeight={150} />
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ color: 'primary.main' }}>
              Verify Code
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
              Enter the 6-digit code sent to {phoneNumber}
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Verification Code"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="123456"
                margin="normal"
                disabled={loading}
                inputProps={{
                  maxLength: 6,
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                sx={{ mt: 3, py: 1.5 }}
                disabled={loading || code.length !== 6}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
              >
                {loading ? 'Verifying...' : 'Verify Code'}
              </Button>

              <Button
                fullWidth
                variant="text"
                size="small"
                sx={{ mt: 2 }}
                onClick={onResendCode}
                disabled={loading}
              >
                Resend Code
              </Button>
            </Box>
          </CardContent>
        </Card>
        </Box>
      </Box>
    </Container>
  );
}

export default VerifyCode;

